import { render, staticRenderFns } from "./contribuicaoPrevidenciaria.vue?vue&type=template&id=51b2631a&"
import script from "./contribuicaoPrevidenciaria.vue?vue&type=script&lang=js&"
export * from "./contribuicaoPrevidenciaria.vue?vue&type=script&lang=js&"
import style0 from "./contribuicaoPrevidenciaria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports